import React from 'react';
import Icon, { Envelope } from 'components/icons';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';

const AwaitingConfirmation = () => (
  <Container className="h-100 h-100 w-100">
    <Row className="d-flex align-items-center h-100">
      <Col />
      <Col lg="6" sm="12" className="text-center">
        <Icon icon={Envelope} size={128} />
        <h2>Thanks for signing up!</h2>
        <h3>Check your inbox for a confirmation email</h3>
        <p>Once you've confirmed, you're ready to start using LaunchNotes.</p>
      </Col>
      <Col />
    </Row>
  </Container>
);

export default AwaitingConfirmation;
